export const EVENT_LINK_TYPES_URL: string = 'account/{accountId}/event/{eventId}/link/type/list';
export const EVENT_LINKS_URL: string = 'account/{accountId}/event/{eventId}/link/list';
export const EVENT_LINK_CREATE_URL: string = 'account/{accountId}/event/{eventId}/link';
export const EVENT_LINK_EDIT_URL: string = 'account/{accountId}/event/{eventId}/link/{linkId}';
